import { useCallback, useEffect, useState } from 'react'
import debounce from 'lodash.debounce'
import useIsMounted from './useIsMounted'

export default function useScreenSize() {
  const [size, setSize] = useState({ width: 0, height: 0 })
  const isMounted = useIsMounted()

  const getScreenSize = useCallback(() => {
    setSize({ width: window.screen.width || window.innerWidth, height: window.screen.height || window.innerHeight })
  }, [])

  useEffect(() => {
    if (isMounted()) getScreenSize()
    const debounced = debounce(getScreenSize, 200)
    window.addEventListener('resize', debounced)
  }, [getScreenSize, isMounted])

  return size
}
